<template>
    <div >
        <h5 v-if="table_type === 'zig_tariffs'" class="text-6 text-black mb-4 pt-3">
            Current ZESA Tariffs  {{ formatDate() }}
        </h5>
        <h5 v-else class="text-6 text-black mb-4 pt-3">
            February Current ZESA Tariffs per Unit
        </h5>
        <div class="table-responsive">
            <table class="table">
                <tbody>
                <tr class="text-black-50">
                    <th>Units (First Purchase)</th>
                    <th>Price {{ table_type === 'zig_tariffs' ? 'in' : 'per unit in' }} ZWG(approx)</th>
                    <th>{{ table_type === 'zig_tariffs' ? 'Price in USD(approx) ' : 'Price per Unit incl. RE Levy' }}</th>
                </tr>
                <tr v-for="tariff in this[table_type]">
                    <td>{{ tariff.band }}</td>
                    <td>{{ tariff.price }}</td>
                    <td>{{  table_type === 'zig_tariffs' ? tariff.priceUSD : tariff.levy   }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--
        <div class="d-flex flex-row ">
            <router-link to="/zesa-calculator"
                         :class="['btn btn-primary btn-sm mr-3']">
                Zesa Calculator
            </router-link>
            <router-link to="/zesa"
                         :class="['btn btn-primary btn-sm']">
                Buy
                ZESA Now
            </router-link>
        </div>
        -->
    </div>
</template>

<script>

export default {
    name:'tariffs-table',
    props: {
        table_type: '',
    },
    data: function () {
        return {
            zig_tariffs: [
                {
                    band: '50 Units/kWh',
                    price: 'ZWG 109.04',
                    priceUSD: 'USD 4.26'
                },
                {
                    band: '100 Units/kWh',
                    price: 'ZWG 231.38',
                    priceUSD: 'USD 9.16'
                },
                {
                    band: '200 Units/kWh',
                    price: 'ZWG 666.49',
                    priceUSD:  'USD 26.10'
                },
                {
                    band: '300 Units/kWh',
                    price: 'ZWG 1293.09',
                    priceUSD:  'USD 50.40'
                },
                {
                    band: '400 Units/kWh',
                    price: 'ZWG 1973.94',
                    priceUSD: 'USD 77.03'
                },
                {
                    band: '500 Units/kWh',
                    price: 'ZWG 2681.38',
                    priceUSD:  'USD 104.42'
                },
                {
                    band: '600 Units/kWh',
                    price: 'ZWG 3388.83',
                    priceUSD:  'USD 131.97'
                }
            ],
            per_unit_tariffs: [
                {
                    band: '1 - 50 Units/kWh',
                    price: 'ZWG 2.16',
                    levy: 'ZWG 2.29'
                },
                {
                    band: '51 - 100 Units/kWh',
                    price: 'ZWG 2.43',
                    levy: 'ZWG 2.58'
                },
                {
                    band: '101 - 200 Units/kWh',
                    price: 'ZWG 4.33',
                    levy: 'ZWG 4.59'
                },
                {
                    band: '201 - 300 Units/kWh',
                    price: 'ZWG 6.23',
                    levy: 'ZWG 6.60'
                },
                {
                    band: '301 - 400 Units/kWh',
                    price: 'ZWG 6.77',
                    levy: 'ZWG 7.17'
                },
                /*{
                    band: '400+ Units/kWh',
                    price: 'USD 0.26',
                    levy: 'USD 0.28'
                }*/
            ]
        };
    },
    methods: {
        formatDate() {
            const date = new Date();
            const options = { month: 'long' };
            const month = new Intl.DateTimeFormat('en-US', options).format(date);
            return `${date.getDate()} ${month} ${date.getFullYear()}`;
        }
    }
}
</script>

